import styled from 'styled-components';

export const Content = styled.section`
  height: 100%;
  padding: 24px;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  overflow-y: auto;
`;
